import {gql} from '@apollo/client'
import {Labels} from '../List/parts/schema'

export const SYSTEM_ANNOUNCE = gql`
  query systemAnnounce($id: ID!) {
    systemAnnounce(id: $id) {
      id
      title
      body
      publishAt
      label
      labelName
    }
  }
`

export type QueryResult = {
  systemAnnounce: {
    id: string
    title: string
    body: string
    publishAt: Date
    label?: Labels
    labelName?: string
  }
}
